const debounce = <T extends Function>(
  func: T,
  wait: number,
  immediate?: boolean
) => {
  let timeout: number;

  return (...args: unknown[]) => {
    const context = this;
    const later = () => {
      timeout = 0;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export default debounce;
